import React, { useState, useEffect } from "react";
// import { MultiSelect } from "primereact/multiselect";
// import "primereact/resources/primereact.css";
// import "primereact/resources/themes/saga-blue/theme.css";
// import { Dropdown } from "primereact/dropdown";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import axios from "axios";
//import { Apis } from "../../Apis/Apis";
//import Alert from "react-bootstrap/Alert";
import Data from "../../Data/data.json";
import "./css/NewsLetter.css";
import { toast, ToastContainer } from "react-toastify";
import { useIsOnline } from "react-use-is-online";
// import ReCAPTCHA from "react-google-recaptcha-v3";
import useFirstRender from "../../hooks/useFirstRender";
import useGeoLocation from "react-ipgeolocation";
import Dynamic_data from "../../Data/Data";
import { useNavigate } from "react-router-dom";
import CountryData from "country-data";
import Cookies from "js-cookie";

const NewsLetter = ({ policy }) => {
  const firstRender = useFirstRender();
  const [selectedInterest, setSelectedIntrest] = useState(null);
  const [selectedEmployeeSize, setSelectedEmployeeSize] = useState(null);
  const [count, setCount] = useState(false);
  const { isOnline, isOffline, error } = useIsOnline();
  const location = useGeoLocation();
  const [phone, setPhone] = useState("");
  const [state, setState] = useState({
    show: false,
    errorList: null,
    emailCheck: true,
  });
  var SITE_KEY = Dynamic_data?.Site_key;
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const navigate = useNavigate();
  let get_cookies_value = Cookies.get("cuvid");

  const emailFormet = Data?.emailFormet;
  const cities = Data?.EmployeeSize;
  const Intrest = Data?.IntrestIn;
  const current_country = String(location.country).toLowerCase();
  let change_to_Upper = current_country.toUpperCase();
  let formate_contry = CountryData.countries[change_to_Upper];
  let GetContryCode = formate_contry && formate_contry?.countryCallingCodes[0];
  // console;
  // console.log("sdsdsd=======><><", GetContryCode);

  const handleOnClick = (e) => {
    e.preventDefault();
    if (isOnline) {
      setLoading(true);
      console.log(window)
      window.grecaptcha.ready(() => {
        window.grecaptcha
          .execute(SITE_KEY, { action: "submit" })
          .then((token) => {
            SubmitForm(e, token);
          });
      });
    } else if (isOffline) {
      setLoading(false);
      setCount(true);
      setTimeout(() => {
        setCount(false);
      }, 3000);
    }
  };

  useEffect(() => {
    if (firstRender) {
      return;
    }
    window.location.reload();
  }, [isOnline]);

  // console.log("cooooooo", isOnline);

  const SubmitForm = async (e, token) => {
    let str = "";
    selectedInterest?.map((element, index) => {
      if (selectedInterest?.length - 1 !== index) {
        str += element?.name + ",";
      } else {
        str += element?.name;
      }
    });

    let data = {
      WorkEmail: e?.target?.Email?.value,
      gRecaptchaResponse: token
    };

    if (state?.emailCheck) {
      let result = await axios({
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        url: Dynamic_data?.Apis_Url?.SubmitNewsLetterForm,
        data: data,
      });
       console.log("form submit news letter result block => ", result);
      if (result?.data?.Result) {
        setSuccessMessage(true);       
            e.target.Email.value = "";
            setLoading(false);
            setState((pre) => ({ ...pre, show: true }));
        
      } else {
        console.log("form submit error => ");
        setLoading(false);
        setState((pre) => ({ ...pre, errorList: result?.data?.ErrorList }));
      }
    }
  };

  useEffect(() => {
    const loadScriptByURL = (id, url, callback) => {
      const isScriptExist = document.getElementById(id);

      if (!isScriptExist) {
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src = url;
        script.id = id;
        script.onload = function () {
          if (callback) callback();
        };
        document.body.appendChild(script);
      }
      if (isScriptExist && callback) callback();
    };

    // Initialize Google Re-Captcha after 5 Seconds
    let timer = setTimeout( function() {

      // load the script by passing the URL
      loadScriptByURL(
        "recaptcha-key",
        `${Data?.googlePath}${SITE_KEY}`,
        function () { }
      );
    }, 5000 );

    // Clear the timer after initializing Google Re-Captcha
    return () => clearTimeout( timer );
  }, []);

  return (
    <section id="getStratedNL">
      <div className="container">
        <div className="col-md-12 col-lg-12 text-center mb-5 nl-head">
          <h2 className="h1">News Letter</h2>
          <p>Subscribe To Our Newsletter </p>
        </div>
            
              <div className="row justify-content-center">
                
                  <form onSubmit={(e) => handleOnClick(e)}>
                    <div className="row g-3">
                      <div className="col-md-12">
                        <input
                          type="email"
                          className={
                            state?.emailCheck
                              ? "form-control"
                              : "form-control form-control-1"
                          } placeholder="*Work Email:" name="Email" required
                        />
                      </div>
                      {!state?.emailCheck ? (
                        <label style={{ color: "red" }}>
                          This is not a Work email
                        </label>
                      ) : null}
                      {loading ? (
                        <label>
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Loading...
                        </label>
                      ) : null}
                      {successMessage ? <div className="alert alert-success">Thank you for subscribing to our newsletter.</div> : ''}
                      <div className="col-12">
                        <div className="row">
                          <div className="col-md-12 text-center">
                            <button
                              data-res=""
                              type="submit"
                              className="rc-primary-btn rc-large-btn rc-btn "
                            >
                              Submit
                            </button>
                          </div>
                          {response && (
                            <label>
                              Output:
                              <br />
                              <pre>
                                {JSON.stringify(response, undefined, 2)}
                              </pre>
                            </label>
                          )}
                        </div>
                      </div>
                    </div>
                  </form>
                
              </div>
        
      </div>
      <ToastContainer />
    </section>
  );
};
export default NewsLetter;
